import axios from 'axios'

import { FreeTextInterface } from '../Interfaces/FreeTextInterface'
import { getRequestConfig } from './index'

export async function getFreeTexts(): Promise<FreeTextInterface[]> {
  const url = '/rest-invoice/api/freetext/context/textrow'
  const response = await axios.get(url, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function saveFreeText(data: FreeTextInterface): Promise<FreeTextInterface> {
  const url = '/rest-invoice/api/freetext'
  const response = await axios.post(url, data, getRequestConfig())
  return Promise.resolve(response.data)
}

export async function deleteFreeText(id: number): Promise<number> {
  const url = `/rest-invoice/api/freetext/id/${id}`
  const response = await axios.delete(url, getRequestConfig())
  return Promise.resolve(response.data)
}
